import React, { useEffect, useState } from "react";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import { toast } from "react-toastify";
import {
  getGladeFollowupDetail,
  getUserData,
  updateFollowUp,
  updateFollowUpRetake,
  updateGladeFollowUp,
} from "../../api/server";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { ReasonAnswers } from "../Common/ReasonAnswers";
import { FiArrowLeft } from "react-icons/fi";
import "./followup.css";

const Followup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id");
  const courseId = queryParams.get("courseId");
  const isGlade = queryParams.get("source") === "glade";
  const retake = Boolean(
    queryParams.get("retake") !== null &&
      queryParams.get("retake") !== "null" &&
      queryParams.get("retake") !== "false" &&
      queryParams.get("retake") !== false
  );

  const [response, setResponse] = useState();
  const [getloading, setGetLoading] = useState(true);
  const [reason, setReason] = useState();

  const [updateLoading, setUpdateLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = isGlade
          ? await getGladeFollowupDetail(userId, courseId)
          : await getUserData(userId);
        setResponse(res.data.data.user);
        const headingsFromBackend = res.data.data.howDid || [];
        const reasonArray = headingsFromBackend
          .filter((heading) => ReasonAnswers[heading])
          .map((heading) => ({
            heading,
            text: ReasonAnswers[heading],
          }));
        setReason(reasonArray);
      } catch (err) {
        toast.error(
          err.response?.data?.error || err.response?.data?.message ||
            "Unable to load follow-up details"
        );
      } finally {
        setGetLoading(false);
      }
    };
    fetchData();
  }, [courseId, isGlade, userId]);

  const handleFolloup = async (type) => {
    try {
      const values = {
        request: type,
        course: "first",
        courseId: courseId,
      };

      if (isGlade) {
        await updateGladeFollowUp(userId, values);
      } else if (retake) {
        await updateFollowUpRetake(userId, values);
      } else {
        await updateFollowUp(userId, values);
      }

      if (type === "attempt") {
        toast.success("Follow-up attempted successfully");
      } else {
        toast.success(`Follow-up ${type} successfully`);
      }
      navigate("/certificates");
    } catch (err) {
      toast.error(
        err.response?.data?.error || err.response?.data?.message ||
          "Unable to update follow-up"
      );
      setUpdateLoading(false);
    }
  };

  const hasJointFiler = isGlade
    ? Boolean(
        response?.joint_firstname ||
          response?.joint_lastname ||
          response?.joint_ssn
      )
    : Boolean(response?.joint_username);

  return (
    <div>
      <div className="wrapper">
        <DashBoardSidebar />
        <div id="content" className="followup-page">
          <DashboardNavbar />
          <header className="followup-page-heading">
            <div className="followup-title-row">
              <h1>Follow up</h1>
              {isGlade && <span className="glade-client-badge">Glade</span>}
            </div>
            <Link to="/certificates" className="followup-back"><FiArrowLeft aria-hidden="true" /> Back</Link>
          </header>
          {getloading || !response ? (
            <p>
              <ThreeDots
                height="40"
                width="80"
                radius="9"
                color="#4fa94d"
                ariaLabel="three-dots-loading"
                wrapperStyle={{
                  display: "flex",
                  justifyContent: "center",
                }}
                wrapperClassName="spinner"
                visible={true}
              />
            </p>
          ) : (
            <>
            <div>
              <section className="followup-card followup-identity">
              <div className="head mt-40">
                <h1 className="f18">Identity Confirmation:</h1>
              </div>
              <p className="mt-3 ms-3">
                Ask the client to verify their name, phone number, as well as
                attorney name (as applicable).
              </p>
              <div className="row mt-4 mb-0 ms-md-1 followup-client-fields">
                <p className="col-md-4">
                  Main Filer{" "}
                  <span className="fw-700">
                    {response.firstname} {response.middleinitial}{" "}
                    {response.lastname}
                  </span>
                </p>
                <p className="col-md-4">
                  {isGlade ? "Client ID" : "Username"}{" "}
                  <span className="fw-700">
                    {isGlade ? response.clientId : response.username}
                  </span>
                </p>
                <p className="col-md-4">
                  {isGlade ? "Last 4 SSN" : "SSN"}{" "}
                  <span className="fw-700">{response.ssn}</span>
                </p>

                {hasJointFiler && (
                  <>
                    <p className="col-md-4">
                      Joint Filer Name{" "}
                      <span className="fw-700">
                        {response.joint_firstname} {response.joint_lastname}
                      </span>
                    </p>
                    <p className="col-md-4">
                      Joint Filer SSN{" "}
                      <span className="fw-700">{response.joint_ssn}</span>
                    </p>
                    {!isGlade && (
                      <p className="col-md-4">
                        Joint Filer Username{" "}
                        <span className="fw-700">{response.joint_username}</span>
                      </p>
                    )}
                  </>
                )}
                <p className="col-md-4">
                  Phone <span className="fw-700">{response.phone}</span>
                </p>
                <p className="col-md-4">
                  Email <span className="fw-700">{response.email}</span>
                </p>
                {response.attorneyname && (
                  <p className="col-md-4">
                    Attorney{" "}
                    <span className="fw-700">{response.attorneyname}</span>
                  </p>
                )}
              </div>
              </section>
              <div className="followup-guidance">
                <section className="followup-card followup-script-card">
<p className="fw-700 mt-4 mb-0">Questions:</p>
                <p className="ms-md-3">
                  Ask if Client(s) has any questions regarding Credit Counseling
                  Session: Remember, the purpose of this call is to ensure
                  client fully participated and understood their online credit
                  counseling session. Ask open-ended questions to encourage
                  client participation.
                </p>
</section>
                <section className="followup-card followup-script-card">
<p className="fw-700 mt-4 mb-0">
                  Review Client's Budget Analysis:
                </p>
                <ol className="ms-md-4">
                  <li>
                    Monthly Household Income and Expenses Overview: Confirm
                    Information provided is full and complete.
                  </li>
                  <li>
                    How'd This Happen: Confirm factors that led to their current
                    financial situation. Use open-ended, judgment-free questions
                    to encourage open dialogue.
                  </li>
                  <li>
                    Detailed Expenses: Highlight areas of overspending, Review
                    Debt-to-Income ratio, and Review Evergreen Suggestions.
                  </li>
                  <li>
                    Detailed Debts: Review Creditor List and Pay-off schedule.
                    Ensure Client understands how to utilize Pay-off Calculator.
                  </li>
                  <li>
                    Client Plan: Confirm Client understands they many ways they
                    can respond to the financial situation.
                  </li>
                </ol>
</section>
                <section className="followup-card followup-script-card">
<p className="fw-700 mt-4 mb-0">Conclusion:</p>
                <p className="ms-md-3">
                  Remind Client of Evergreen motto: True Worth. “At times it
                  appears as if everything in life has a price tag. However, you
                  as a person are priceless, regardless of how much money you
                  have or owe.”
                </p>
</section>
                <section className="followup-card followup-script-card">
<p className="fw-700 mt-4 mb-0">Certificate Delivery: </p>
                <p className="ms-md-3">Verify email address</p>
</section>
              </div>
              {reason && reason.length > 0 && (
                  <div className="followup-reasons">
                    <h4 className="card-title">How'd this happen</h4>
                    {reason.map((item, index) => (
                      <div key={index} className="followup-card followup-reason-card">
                        <div className="head mt-40">
                          <h1 className="f18">{item.heading}:</h1>
                        </div>
                        <p className="mt-3 ms-3">{item.text}</p>
                      </div>
                    ))}
                  </div>
                )
                }
              <div className="btn_wrap mt-40 text-center followup-actions">
                  <Link
                    className="btn_brnd-outline"
                    to={
                      isGlade
                        ? `/glade-client-details?id=${userId}`
                        : `/editstudent?id=${userId}`
                    }
                  >
                    View Full Account
                  </Link>
                <button
                  className="btn_brnd  me-4 mb-3"
                  onClick={() => {
                    setUpdateLoading("completed");
                    handleFolloup("completed");
                  }}
                  disabled={updateLoading}
                >
                  {updateLoading === "completed" ? (
                    <ThreeDots
                      height="20"
                      width="75"
                      radius="9"
                      color="#4fa94d"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{
                        display: "block",
                      }}
                      wrapperClassName="spinner"
                      visible={true}
                    />
                  ) : (
                    "Complete"
                  )}
                </button>
                <button
                  className="btn_brnd  me-4 mb-3"
                  onClick={() => {
                    setUpdateLoading("attempt");
                    handleFolloup("attempt");
                  }}
                  disabled={updateLoading}
                >
                  {updateLoading === "attempt" ? (
                    <ThreeDots
                      height="20"
                      width="75"
                      radius="9"
                      color="#4fa94d"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{
                        display: "block",
                      }}
                      wrapperClassName="spinner"
                      visible={true}
                    />
                  ) : (
                    "Attempt"
                  )}
                </button>
                <button
                  className="btn_delete btn_brnd"
                  onClick={() => {
                    setUpdateLoading("archived");
                    handleFolloup("archived");
                  }}
                  disabled={updateLoading}
                >
                  {updateLoading === "archived" ? (
                    <ThreeDots
                      height="20"
                      width="75"
                      radius="9"
                      color="#4fa94d"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{
                        display: "block",
                      }}
                      wrapperClassName="spinner"
                      visible={true}
                    />
                  ) : (
                    "Archive"
                  )}
                </button>
              </div>
            </div>
            
                
            </>
          )}
          
        </div>
      </div>
    </div>
  );
};

export default Followup;
